import React, { useEffect } from "react";
import { useAuth } from "../Context/AuthContext/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppContext } from "../Context/AppContext/AppContext";

const ProtectedLogin: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isUserLoggedIn } = useAuth();
  const { isBasePlanExpired } = useAppContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isUserLoggedIn) {
      const redirectUrl = searchParams.get("redirect_url");
      if (redirectUrl) {
        let decodedUrl = decodeURIComponent(redirectUrl);
        const isSafeRedirect =
          decodedUrl.startsWith("/") && !decodedUrl.startsWith("//");

        if (isSafeRedirect) {
          const additionalParams: string[] = [];
          searchParams.forEach((value, key) => {
            if (key !== "redirect_url") {
              additionalParams.push(`${key}=${value}`);
            }
          });

          if (additionalParams.length > 0) {
            const separator = decodedUrl.includes("?") ? "&" : "?";
            decodedUrl = `${decodedUrl}${separator}${additionalParams.join("&")}`;
          }

          navigate(decodedUrl);
        } else {
          navigate("/");
        }
      } else {
        navigate("/");
      }
    } else if (isBasePlanExpired) {
      navigate("/");
    }
  }, [isUserLoggedIn, navigate, isBasePlanExpired, searchParams]);

  return <>{!isUserLoggedIn && !isBasePlanExpired ? children : null}</>;
};

export default ProtectedLogin;
